import { FC } from 'react';

interface IChatCheckIconProps {
  stroke?: string;
}

const ChatCheckIcon: FC<IChatCheckIconProps> = (props) => {
  const { stroke } = props;
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1L3.5 6.5L1 4"
        stroke={stroke ?? '#98A2B3'}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChatCheckIcon;
